
import React, { useState, useEffect , useRef} from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { DataView } from 'primereact/dataview';
import { Rating } from 'primereact/rating';
import { Paginator } from 'primereact/paginator';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';

import ConfirmaCita from './ConfirmaCita';

import DialogCard from './Dialogs/DialogCard';

import { Toast } from 'primereact/toast';


import axios from 'axios';

import { getUrl } from '../../../../../ApiCall/GetUrl';

// import {ConfirmaCita} from "./ConfirmarCita"

import  "./AgendaUnaCita.css"
//import { h } from '@fullcalendar/core/preact.js';

export default function Tarjeta( { state } ) {
/*
  function getUrl() {
    return "https://boxy.currenmexico.com/legalup";
    // return "http://localhost:3005/legalup";
  }
  function getUrlBack() {
    return "https://boxy.currenmexico.com";
    // return "http://localhost:3005/legalup";
  }
*/
  var [lawyers, setLawyers] = useState([]);
  var [horarios, setHorarios] = useState([]);
  var [horariosFull,setHorariosFull] = useState( [] )
  var [value, setValue] = useState(null);
  const [myState,setTheState] = useState( false )
  const [theClient,setTheClient] = useState( null )
  const [pending,setPending] = useState( null )


  const [isVisible , setIsVisible] = useState( false ) ; // De entrada no se ve el dialogo 

  const toast = useRef()


  useEffect (() => {


    console.log( "Cambio de state = " , myState )

  } , [myState])

  useEffect(() => {

    console.log( "isVisible = " , isVisible)

  } , [isVisible])

  function theAnswer(val)
  {
    console.log( "theAnswer = " , val )
    //setPending( val ) // val.target.attributes["client"].value

    var thePending = pending ;

    console.log( "theAnswer = " , thePending.target.attributes )

    thePending.target.attributes['client'].value = val.id 

    console.log( "thePending  = " , thePending )

    if( val.status === 0 )
    {

      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Usuario registrado Correctamente', life: 6000 });


    }

    setIsVisible( false )

    onClick( thePending )
  }

  function theNotVisible( )
  {
    console.log( "theNotVisible")
    setIsVisible( false )

    if ( pending !== null )
    {
      console.log( "pending = " , pending )
    }
  }


  useEffect(() => {
    console.log( "Entrando a tarjeta***")
  } ,[])

  function confirmCalendar( comment  )
  {
    console.log( "Confirm tarjeta = " , theClient )
    console.log( "Comment = " + comment ) ;

    var myClient = theClient ;
    myClient.comment = comment ;

    //console.log( "myClient = " , myClient )

    //return ;

    axios.post( getUrl() + "/confirmacita" , myClient )
    .then((response) => {

      console.log( response )

      setHorarios( [])

      getHorarios() ; // Recargamos los horarios

    })
    .catch((err)=>{
      console.log( err) ;
    })



  }

  useEffect(() => {

    console.log( "Tarjeta theState = " , myState ) ;

  } , [myState])

  const months = {
    1: "Enero",
    2: "Febrero",
    3: "Marzo",
    4: "Abril",
    5: "Mayo",
    6: "Junio",
    7: "Julio",
    8: "Agosto",
    9: "Septiembre",
    10: "Octubre",
    11: "Noviembre",
    12: "Diciembre"
  };

  function onOver(event)
  {
    event.target.style.borderColor = 'black';
  }

  function onOut(event)
  {
    event.target.style.borderColor = 'transparent';
  }

  // [ { id :1 , horarios : [ ] } , { id :2 , horarios : [ ] }  ]



  function onClick( val )
  {

    console.log( "setIsVisible = true *******" + val.target.attributes["client"].value )

    console.log( "Stetus =  " + val.target.attributes["status"].value )


    //return ;


    if ( val.target.attributes["client"].value === '0'  && val.target.attributes["status"].value === "1" )
    {
      console.log( "Entramos a prenderlo")
      setPending( val) ; // Guardamos la referencia pendiente
      setIsVisible( true ) ;
      return ; 
    }

    

    

    //console.log( "client = " , event.target.current.client ) ;
    console.log( "client = " , val.target.attributes["client"].value ) // day={0} hour={'08:00'}
    console.log( "day = " , val.target.attributes["day"].value ) 
    console.log( "hour = " , val.target.attributes["hour"].value ) 

    var status = val.target.attributes["status"].value
    console.log( "status = " , status )


    if ( status === "2")
    {

      console.log( "Saliendo por 2")
      
      return ;
    }
    
      var result = new Date();
      result.setDate(result.getDate() + parseInt( val.target.attributes["day"].value) );
    
    var obj = {

      idcalendar : val.target.attributes["idcalendar"].value ,
      idlawyer : val.target.attributes["lawyer"].value , // Hay que traerlo
      idclient : val.target.attributes["client"].value ,
      //day : val.target.attributes["day"].value ,

      //hour : val.target.attributes["hour"].value ,

      datetime : getFormatDateShort( result ) + " " + val.target.attributes["hour"].value , 
      status : 2 // Cita confirmada
      

    }
    setTheClient( obj ) ;
    setTheState(  myState =>  !myState   ) ;
    console.log( "onClick = " , myState )
    // val.target.attributes["row"]
  }

  var columns = [];
  let fecha = new Date();


  for (let i = 0; i < 14; i++) {
    var obj = { field: i.toString() /*fecha.getDate()*/, header: `${fecha.getDate()} ${months[(fecha.getMonth() % 12) + 1]}` };
    columns.push(obj);
 
    fecha.setDate(fecha.getDate() + 1);
  }
  var navigate = useNavigate();
  // const location = useLocation();

  const navigateAux = (id) => {
   

    console.log( "navigateAux = " , id ) 

    //return ;

    if( id === null || state.id === 0 ) {
      return;
    }
    navigate("/info", {state: {id:id }})
    
    
  }


  // const id = location.state.id;
  // const registro = location.state.register;

  useEffect(() => {

    console.log( "Cargando pagina " , getUrl())

    //axios.get("http://boxy.currenmexico.com/legalup/getLawyerDashboard").then(response => {
    axios.get(getUrl() +  "/getLawyerDashboard").then(response => {
      setLawyers(response.data);
      //console.log("Este es el response.data: ", response.data);
      //getHorarios() ;
    }).catch(error => {
      console.log("Error fetching data: ", error)
      setLawyers(["Hubo un error al obtener la información"])
    });

    //axios.get("http://boxy.currenmexico.com/legalup/getHorarios").then(response => {
/*
    axios.get( getUrl() + "/horarioslawyer").then(response => {

      console.log( "horarioslawyer = " , response.data ) ;
      //setHorarios([]);
      setHorarios( myHorarios )
      console.log("Este es el response data de horarios: ", response.data);
    }).catch(error => {
      console.log("Error fetching data de horarios: ", error);
      setHorarios(["Hubo un error al obtener la información"]);
    })
*/

  }, []);

  useEffect(() => {

    if ( lawyers.length > 0 )
    {
      getHorarios() ;
    }

  },[lawyers])

  function getHorarios()
  {
    axios.get( getUrl() + "/horarioslawyer").then(response => {

      console.log( "horarioslawyer = " , response.data ) ;
      //setHorarios([]);
      setHorarios( response.data )
      console.log("Este es el response data de horarios: ", response.data);

      //buildHorarios() ;

    }).catch(error => {
      console.log("Error fetching data de horarios: ", error);
      setHorarios(["Hubo un error al obtener la información"]);
    })
  }


  useEffect( () => {
    if ( horarios.length > 0 )
    {
      var theHorarios = buildHorarios()

      setHorariosFull( theHorarios ) ;
    }
    
  } ,[horarios])


  function buildHorarios()
  {
    var arr = [] ;

    console.log( "lawyers.length = " + lawyers.length ) 

    for( var i = 0 ; i < lawyers.length ; i++ ) // Recorremos cada uno de los horarios
    {
      var obj ={

        id : lawyers[i].id ,
        horarios : fillEmpty( lawyers[i].id )

      }

      arr.push( obj ) ;

    }

    //console.log( "Aqui va el primer cliente ---")
    //console.log( arr )

    return arr ;
  }

  function fillEmpty( id  ) // dd del cliente
  {

    //console.log( "A procesar " + id )

    var arr = []

    var hrs = [

      "08:00" ,
      "08:30" ,
      "09:00" ,
      "09:30" ,
      "10:00" ,
      "10:30" ,
      "11:00" ,
      "11:30" ,
      "12:00" ,
      "12:30" ,
      "13:00" ,
      "13:30" ,
      "14:00" ,
      "14:30" ,
      "15:00" ,
      "15:30" ,
      "16:00" ,
      "16:30" ,
      "17:00" ,
      "17:30" ,
      "18:00" ,
      "18:30" ,
      "19:00" ,
      "19:30" ,
      "20:00" ,
      "20:30" ,

    ]

    for( var i = 0 ; i < 26 ; i++ ) // Todos los horarios
    {

      var row = [] // Este es un renglon con horarios
      
      for( var  j = 0 ; j < 14 ; j++ ) // todos los dias
      {

        //console.log( "horarios.length = " + horarios.length + " id = " + id )

        var horariofound = "----"

        var isFound = false ;

        for( var k = 0 ; k < horarios.length ; k++ )
        {
          //console.log( "horarios.datetime = " + horarios[k].datetime + " cliente = " + id )

          var localDate = new Date( horarios[k].datetime )

          localDate.setHours(localDate.getHours() + 2);

          var strDate = getFormatDate( localDate )

          //console.log( "strDate = " + strDate ) ; // 11 , 5

          strDate = strDate.substring( 11 , 16 )

          //console.log( "strDate = " + strDate )

          var theDiff = dateDiffInDays( new Date() , localDate ) ;

          //var isFound = false ;

           if ( horarios[k].idlawyer === id && theDiff === j )
           {
              //console.log( "k = " + k)

              if ( strDate === hrs[i])
              {
                console.log( "strDate = " + strDate + " hrs = " + hrs[i] + " index = " + i )
                console.log( "Si encontramos horario en el cliente******** " + id + " dia = " + theDiff )
                console.log( "localdate = " + localDate )
                console.log( "Siguiente = " + hrs[i+1])


                horariofound = <button onMouseOver={onOver} client={state.id} idcalendar={horarios[k].id}
                  lawyer={id} day={theDiff} hour={hrs[i]}  status={horarios[k].status}
                  title= { horarios[k].status === 1 ? 'Disponible' : "Reservado" }
                  onMouseOut={onOut} onClick={(val) => onClick(val)} 
                  style={{borderRadius :'4px' , width : '70px' , textDecoration :  horarios[k].status === 2 ? 'line-through' : '' ,
                    height :'35px' , color : "black" , borderColor : 'transparent' , backgroundColor : "rgb(238,244,256)"}}>{hrs[i]}</button> 

                isFound = true ;

              }

           
            }

            if ( !isFound )
            {
              horariofound = <p style={{textDecoration : 'line-through'}}>{hrs[i]} </p>
            }

        }

        row.push( horariofound )
      }

      arr.push( row )

    }

    return arr ;

  }

  function dateDiffInDays(d1 , d2) {
    d2.setHours( 0 , 0 , 0 , 0 ) // date.setHours(0, 0, 0, 0)
    d1.setHours( 0 , 0 , 0 , 0 )

    var t2 = d2.getTime();
    var t1 = d1.getTime();

    

    return Math.floor((t2-t1)/(24*3600*1000));

}


function getFormatDate(d) {
  var date = new Date(d);
  var dateStr =
      date.getFullYear() + "-" +
      ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
      ("00" + date.getDate()).slice(-2) + " " +
    ("00" + date.getHours()).slice(-2) + ":" +
    ("00" + date.getMinutes()).slice(-2) + ":" +
    ("00" + date.getSeconds()).slice(-2);
  //console.log(dateStr);

  return dateStr;
}

function getFormatDateShort(d) {
  var date = new Date(d);
  var dateStr =
      date.getFullYear() + "-" +
      ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
      ("00" + date.getDate()).slice(-2) 

  //console.log(dateStr);

    return dateStr;
}


  const getSeverity = (product) => {
    switch (product.inventoryStatus) {
      case 'Disponible':
        return 'success';

      case 'Ocupado':
        return 'warning';

      case 'Sin fechas':
        return 'danger';

      default:
        return null;
    }
  };

  // Especialidad
  // Estado 
  // Ciudad (Opcional)

  const itemTemplate = (lawyer, ind) => { // Antes era index ahora es ind
    return (
      <div className='row each_card'>
        <div className="col" key={lawyers.id}>
          <div className={classNames('flex flex-column xl:flex-row xl:align-items-start p-4 gap-4', { 'border-top-1 surface-border': ind !== 0 })}>
            <img className="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round" src={lawyer.image} alt={lawyer.name + " " + lawyer.apellidoP + " " + lawyer.apellidoM} />
            <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
              <div className="flex flex-column align-items-center sm:align-items-start gap-3">
                <div className="text-2xl font-bold text-900"  ><h4 style={{cursor:'grab'}} onClick={() => {
                  return navigateAux(lawyer.id)
                }}>{lawyer.name + " " + lawyer.apellidoP + " " + lawyer.apellidoM} </h4></div>
                <Rating value={lawyer.rating} readOnly cancel={false}></Rating>
                <span className='text-description'>{lawyer.firstCharge === null ? "Tú primera cita es gratis" : "El costo mostrado aplica solo en la primera cita"}</span>
                <div className="flex align-items-center gap-3">
                  <span className="flex align-items-center gap-2">
                    <i className="pi pi-tag"></i>
                  </span>
                </div>

                <div className="flex gap-2">

                  <div className='  align-items-center' 
                    style={{borderStyle:'solid' , borderWidth :'1' , borderRadius :'5px' , cursor :'grab' }}>
                    <i className='pi pi-users' style={{ fontSize: '1.5rem' }}></i>
                    <p className='mb-2'>CitaPresencial</p>
                  </div>

                  <div className=' align-items-center' 
                    style={{borderStyle:'solid' , borderWidth :'1' , borderRadius :'5px' , cursor :'grab'}}>
                    <i className='pi pi-video' style={{ fontSize: '1.5rem' }}></i>
                    <p className='mb-2'>Videollamada</p>
                  </div>
{/* 
                  <span className="flex align-items-center gap-2">
                    <i className='pi pi-users' style={{ fontSize: '1.5rem' }}></i>
                    <p>CitaPresencial</p>
                  </span>
                  <span className="flex align-items-center gap-2">
                    <i className='pi pi-video' style={{ fontSize: '1.5rem' }}></i>
                    <p>Videollamada</p>
                  </span> */}

                </div>


              </div>
              <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                <span className="text-2xl font-semibold">{(lawyer.firstCharge === null) ? " " : ("$" + lawyer.lawyer_first_charge)}</span>
              </div>
            </div>

            <div className='col' style={{ overflowX: 'auto', maxWidth: '100%' , minHeight : '200px'}}>
              <DataTable value={ ( ind >= 0 ?  horariosFull[ind]?.horarios : [])   /*horarios[lawyer[]]*/} tableStyle={{ minWidth: '50rem' , minHeight :'180px'}} scrollable scrollHeight="400px">
                {columns.map( (col , index ) => {
                  return <Column key={index} field={index.toString()} header={col.header} style={{height:'20px'}} />
                })}
              </DataTable>
            </div>
          </div>

        </div>
      </div>
    );
  };

  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div className="grid grid-nogutter">{list}</div>;
  };

  return (
    <div className="card">
      <DataView value={lawyers} listTemplate={listTemplate} />

      <ConfirmaCita theState={myState}  confirmCalendar={confirmCalendar} cancela={() => setPending(null)}></ConfirmaCita>

      <DialogCard isvisible={isVisible} answer={theAnswer}
        notVisible={() => theNotVisible()}></DialogCard>

        <Toast ref={toast} />
    </div>
  )
}


